import React from 'react'
import Dashboard from '../../componentsL/Dashboard'

const Admin = () => {

  return (
    <div>
      <Dashboard />
    </div>
  )
}

export default Admin